// @ts-expect-error
import {createAction} from 'redux-act';

import type {
    ComparedActivityReportSummary,
    ComparisonRangeType,
    ReportRowData,
} from 'nutshell-core/types';

export const ActionTypes = {
    QUOTES_REPORT_FETCH_SUMMARY_REQUEST: 'QUOTES_REPORT_FETCH_SUMMARY_REQUEST',
    QUOTES_REPORT_FETCH_SUMMARY_SUCCESS: 'QUOTES_REPORT_FETCH_SUMMARY_SUCCESS',
    QUOTES_REPORT_FETCH_SUMMARY_FAILURE: 'QUOTES_REPORT_FETCH_SUMMARY_FAILURE',
} as const;

type SummaryRequestPayload = {
    filters: any;
    comparisonType: ComparisonRangeType | null | undefined;
};
type SummaryPayload = {
    data: ComparedActivityReportSummary<Array<ReportRowData>>;
    totals: ComparedActivityReportSummary<ReportRowData>;
};

export type QuotesReportSummaryRequestAction = {
    type: 'QUOTES_REPORT_FETCH_SUMMARY_REQUEST';
    payload: SummaryRequestPayload;
};
export type QuotesReportSummarySuccessAction = {
    type: 'QUOTES_REPORT_FETCH_SUMMARY_SUCCESS';
    payload: SummaryPayload;
};
export type QuotesReportSummaryFailureAction = {
    type: 'QUOTES_REPORT_FETCH_SUMMARY_FAILURE';
    error: true;
    payload: unknown | null | undefined;
};

export type QuotesReportAction =
    | QuotesReportSummaryRequestAction
    | QuotesReportSummarySuccessAction
    | QuotesReportSummaryFailureAction;

/*------------------------------------------------------------------------------
| Action Creators
| ------------------------------------------------------------------------------*/
export const requestQuotesReportActivities = createAction('QUOTES_REPORT_ACTIVITIES_REQUESTED');
export const updateQuotesReportActivities = createAction('QUOTES_REPORT_ACTIVITIES_UPDATED');
export const failQuotesReportActivities = createAction('QUOTES_REPORT_ACTIVITIES_FAILED');

export const requestQuotesReportSummary = (
    payload: SummaryRequestPayload
): QuotesReportSummaryRequestAction => ({type: 'QUOTES_REPORT_FETCH_SUMMARY_REQUEST', payload});
export const resolveQuotesReportSummary = (
    payload: SummaryPayload
): QuotesReportSummarySuccessAction => ({type: 'QUOTES_REPORT_FETCH_SUMMARY_SUCCESS', payload});
export const failQuotesReportSummary = (err: unknown): QuotesReportSummaryFailureAction => ({
    type: 'QUOTES_REPORT_FETCH_SUMMARY_FAILURE',
    payload: err,
    error: true,
});
